import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCodeBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.522 2.272a.75.75 0 0 1 .547.91L7.513 9.419a.75.75 0 0 1-1.455-.363L7.613 2.82a.75.75 0 0 1 .91-.547ZM4.998 3.44a.75.75 0 0 1 .063 1.06L3.503 6.25l1.558 1.752a.75.75 0 1 1-1.122.996L2.058 6.881a.95.95 0 0 1 0-1.262l1.881-2.117A.75.75 0 0 1 5 3.439Zm5.004 0a.75.75 0 0 1 1.059.063l1.882 2.117a.95.95 0 0 1 0 1.262L11.06 8.998a.75.75 0 0 1-1.122-.996l1.557-1.752L9.94 4.498a.75.75 0 0 1 .063-1.059ZM14.75 5a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25v5.305c0 1.191 0 2.161-.103 2.926-.107.798-.338 1.484-.885 2.031s-1.234.779-2.032.886c-.765.103-1.735.103-2.926.103H8.196c-1.192 0-2.161 0-2.926-.103-.798-.107-1.484-.339-2.031-.886s-.779-1.233-.886-2.031c-.103-.765-.103-1.735-.103-2.926v-.138a.75.75 0 0 1 1.5 0v.084c0 1.258.002 2.127.09 2.78.084.632.237.949.46 1.17.221.222.538.375 1.17.46.653.088 1.521.09 2.78.09h3.5c1.259 0 2.127-.002 2.78-.09.632-.085.949-.238 1.17-.46.223-.221.376-.538.46-1.17.088-.653.09-1.522.09-2.78V6.5a.75.75 0 0 0-.75-.75.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCodeBlock;
